<div class="rte-shell">

  <div class="rte-shell__toolbar">
    <div class="rte-shell__toolbar-left">
      <mat-icon class="rte-shell__toolbar-icon">edit_note</mat-icon>
      <span class="rte-shell__toolbar-title">{{ 'Template Editor' | translate }}</span>
    </div>
    <div class="rte-shell__toolbar-right">
      <span class="rte-shell__preview-toggle-label">{{ 'Live Preview' | translate }}</span>
      <mat-slide-toggle
        [checked]="config.showLivePreview"
        (change)="onTogglePreview()"
        color="primary"
        class="rte-shell__preview-toggle">
      </mat-slide-toggle>
    </div>
  </div>

  <app-validation-banner [issues]="validationIssues"></app-validation-banner>

  <div class="rte-shell__body">

    <div class="rte-shell__sidebar" [class.rte-shell__sidebar--collapsed]="sidebarCollapsed">
      <button class="rte-shell__sidebar-toggle" (click)="toggleSidebar()" [title]="(sidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar') | translate">
        <mat-icon>{{ sidebarCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
      </button>
      @if (sidebarCollapsed) {
        <span class="rte-shell__sidebar-vertical-label">
          {{ 'Fields / Properties' | translate }}
        </span>
      }

      @if (!sidebarCollapsed) {
        <div class="rte-shell__tabs">
          <button class="rte-shell__tab" [class.rte-shell__tab--active]="activeTab === EditorTab.Palette"
            (click)="activeTab = EditorTab.Palette">
            <mat-icon>data_object</mat-icon>
            {{ 'Fields' | translate }}
          </button>
          <button class="rte-shell__tab" [class.rte-shell__tab--active]="activeTab === EditorTab.Properties"
            (click)="activeTab = EditorTab.Properties">
            <mat-icon>tune</mat-icon>
            {{ 'Properties' | translate }}
          </button>
        </div>
        @if (activeTab === EditorTab.Palette) {
          <div class="rte-shell__tab-content">
            <app-placeholder-palette [fields]="paletteFields" [runtimeGroups]="paletteRuntimeGroups"
              [contextFields]="contextFields" [contextLabel]="contextLabel" [hasLoopScopes]="hasLoopScopes"
              (fieldInserted)="onFieldInserted($event)">
            </app-placeholder-palette>
          </div>
        }
        @if (activeTab === EditorTab.Properties) {
          <div class="rte-shell__tab-content">
            <app-widget-property-panel
              [selectedWidgetTag]="selectedWidgetTag"
              [widgetProperties]="widgetProperties"
              [printOptions]="localPrintOptions"
              [entityType]="config.entityType"
              (propertiesChanged)="onWidgetPropertiesChanged($event)"
              (printOptionsChanged)="onPrintOptionsChanged($event)">
            </app-widget-property-panel>
          </div>
        }
      }
    </div>

    <div class="rte-shell__editor-area">
      @if (Editor && editorConfig) {
        <div class="rte-shell__ckeditor-wrap">
          <ckeditor [editor]="Editor" [config]="editorConfig" [data]="editorHtml"
            (change)="onEditorChange($event.editor.getData())"
            (ready)="onEditorReady($event)">
          </ckeditor>
        </div>
      }
      @if (!Editor) {
        <div class="rte-shell__editor-loading">
          <app-rings-loader></app-rings-loader>
        </div>
      }
    </div>

    @if (config.showLivePreview) {
      <div class="rte-shell__preview">
        <div class="rte-shell__preview-header">
          <mat-icon>preview</mat-icon>
          {{ 'Live Preview' | translate }}
        </div>
        <div #previewContentEl class="rte-shell__preview-content html-preview-content">
          <div #previewPageEl class="rte-shell__preview-page" [innerHTML]="config.htmlPreview"></div>
        </div>
      </div>
    }

  </div>

  <div class="rte-shell__footer">
    <button class="btn rte-btn rte-btn--outline" (click)="discard()" [disabled]="isSaving">
      <mat-icon>close</mat-icon>
      {{ 'Discard' | translate }}
    </button>
    <button class="btn rte-btn rte-btn--outline-pdf" (click)="requestPdf()" [disabled]="isSaving">
      <mat-icon>picture_as_pdf</mat-icon>
      {{ 'Preview as PDF' | translate }}
    </button>
    <button class="btn rte-btn rte-btn--primary" (click)="save()" [disabled]="isSaving">
      <mat-icon>save</mat-icon>
      {{ 'Save' | translate }}
    </button>
  </div>

  <app-editor-tour #tour [steps]="tourSteps" tourId="report-template-editor-v2"></app-editor-tour>

</div>
